"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbMenuItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _value = require("../../skybase-core/utils/value");

var _keyCodes = require("../../skybase-core/constants/keyCodes");

var _browser = require("../../skybase-core/utils/browser");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Returns the menu item
var SbMenuItem = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbMenuItem, _PureComponent);

  var _super = _createSuper(SbMenuItem);

  function SbMenuItem(props) {
    var _this;

    _classCallCheck(this, SbMenuItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
      // If this.touchClick is false, then it is a standard click.
      if (!_this.touchClick) {
        var _this$props = _this.props,
            onClick = _this$props.onClick,
            url = _this$props.url,
            handleOnParentMouseLeave = _this$props.handleOnParentMouseLeave; // Makes sure that the menu is closed when an item is clicked.

        if (handleOnParentMouseLeave) {
          handleOnParentMouseLeave();
        }

        _this.handleOnMouseLeave();
        /**
         * Prevent the default redirect action.
         * (href is used only on clicking with the "scroll" button - open in new tab, or right click - open in new tab)
         * */


        if (!event.ctrlKey && !event.metaKey) {
          event.preventDefault();
          onClick(url, event);
        }
      } else {
        // If the this.touchClick is true, only prevent the default click event and make the touch handler do the rest.
        event.preventDefault();
      } // Reset the this.touchClick variable on every click.


      _this.touchClick = false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnKeyUp", function (event) {
      var keyCode = event.keyCode;
      event.stopPropagation();

      if (keyCode === _keyCodes.enter) {
        _this.handleOnClick(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isActive", function () {
      var _this$props2 = _this.props,
          handleActive = _this$props2.handleActive,
          url = _this$props2.url,
          currentUrl = _this$props2.currentUrl;

      if (handleActive) {
        return handleActive(url, currentUrl);
      }

      if (currentUrl || currentUrl === '') {
        // The / is added to the path to make sure that it's a subpath that is selected.
        return currentUrl.startsWith("".concat(url, "/")) && url !== (0, _browser.getAppRoot)() || url === currentUrl;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "getClassNames", function (isActive) {
      return {
        'sb-menu-item': true,
        active: isActive
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseEnter", function () {
      _this.setState({
        mouseOver: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseLeave", function () {
      _this.setState({
        mouseOver: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnTouch", function () {
      // Touch events are fired before the onClick, so we set the this.touchClick to true.
      // In the onClick, we check this variable and act accordingly.
      _this.touchClick = true;

      _this.setState(function (prevState) {
        return {
          mouseOver: !prevState.mouseOver
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderIcon", function (content) {
      var badge = _this.props.badge;
      return content && /*#__PURE__*/_react.default.createElement("span", {
        className: "sb-menu-icon"
      }, content, !(0, _value.isNullOrUndefined)(badge) && /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-badge"
      }, badge));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAnchor", function (_ref) {
      var _ref$anchorIcon = _ref.anchorIcon,
          anchorIcon = _ref$anchorIcon === void 0 ? null : _ref$anchorIcon,
          anchorTitle = _ref.anchorTitle,
          _ref$touchable = _ref.touchable,
          touchable = _ref$touchable === void 0 ? false : _ref$touchable;
      var _this$props3 = _this.props,
          url = _this$props3.url,
          handleOnParentMouseEnter = _this$props3.handleOnParentMouseEnter,
          handleOnParentMouseLeave = _this$props3.handleOnParentMouseLeave; // Create href url from appRoot and url, and remove the possible duplicate forward slashes

      var href = "".concat((0, _browser.getAppRoot)()).concat(url).replace(/\/\/+/g, '/'); // If there are parent handlers available, it means that this anchor is already a children of wrapper.
      // touchable is the part of the anchor, which acts differently when there is a touch event.

      return /*#__PURE__*/_react.default.createElement("a", {
        href: href,
        onClick: _this.handleOnClick,
        onMouseEnter: handleOnParentMouseEnter !== null && handleOnParentMouseEnter !== void 0 ? handleOnParentMouseEnter : _this.handleOnMouseEnter,
        onMouseLeave: handleOnParentMouseLeave !== null && handleOnParentMouseLeave !== void 0 ? handleOnParentMouseLeave : _this.handleOnMouseLeave,
        onTouchEnd: touchable ? _this.handleOnTouch : null
      }, _this.renderIcon(anchorIcon), /*#__PURE__*/_react.default.createElement("span", null, anchorTitle));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAnchorWrapper", function (_ref2) {
      var anchorIcon = _ref2.anchorIcon,
          anchorTitle = _ref2.anchorTitle,
          id = _ref2.id;
      var mouseOver = _this.state.mouseOver;
      var _this$props4 = _this.props,
          isCollapsed = _this$props4.isCollapsed,
          isChildren = _this$props4.isChildren,
          children = _this$props4.children,
          hoverItemsClassName = _this$props4.hoverItemsClassName; // Menu is not collapsed, render standard anchors.

      if (!isCollapsed) {
        return _this.renderAnchor({
          anchorIcon: anchorIcon,
          anchorTitle: anchorTitle
        });
      } // This anchor wrapper is already a children of another wrapper,
      // which means we only have to render an anchor (to avoid multi nesting).


      if (isChildren) {
        return _this.renderAnchor({
          anchorTitle: anchorTitle
        });
      }

      var tetheredId = "thethered-".concat(id);
      return /*#__PURE__*/_react.default.createElement(_reactTether.default, {
        attachment: "top left",
        constraints: [{
          to: 'scrollParent'
        }],
        targetAttachment: "auto auto",
        className: (0, _classnames.default)('sb-menu sb-menu-item-collapsed-menu-hover-items', hoverItemsClassName),
        offset: "50px 0"
      }, _this.renderAnchor({
        anchorIcon: anchorIcon,
        anchorTitle: anchorTitle,
        touchable: true
      }), mouseOver && /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
        id: tetheredId
      }, _this.renderAnchor({
        anchorTitle: anchorTitle
      })), _react.default.Children.map(children, function (child) {
        // Since we render children, we inject the isChildren prop as true and pass down the mouse handlers from its parent.
        return _react.default.cloneElement(child, {
          isChildren: true,
          handleOnParentMouseEnter: _this.handleOnMouseEnter,
          handleOnParentMouseLeave: _this.handleOnMouseLeave
        });
      })));
    });

    _this.state = {
      mouseOver: false
    };
    _this.touchClick = false;
    return _this;
  }

  _createClass(SbMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          className = _this$props5.className,
          isCollapsed = _this$props5.isCollapsed,
          children = _this$props5.children,
          icon = _this$props5.icon,
          id = _this$props5.id,
          title = _this$props5.title;
      var isActive = this.isActive();
      return /*#__PURE__*/_react.default.createElement("li", {
        id: id,
        onKeyUp: this.handleOnKeyUp,
        className: (0, _classnames.default)('sb-list-menu-item', className),
        tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex

      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(this.getClassNames(isActive))
      }, this.renderAnchorWrapper({
        anchorIcon: icon,
        anchorTitle: title,
        id: id
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-after-link"
      }), isActive && !isCollapsed && /*#__PURE__*/_react.default.createElement("ul", {
        className: "sb-menu-subitem"
      }, children));
    }
  }]);

  return SbMenuItem;
}(_react.PureComponent);

exports.SbMenuItem = SbMenuItem;

_defineProperty(SbMenuItem, "propTypes", {
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  currentUrl: _propTypes.default.string,
  handleActive: _propTypes.default.func,
  hint: _propTypes.default.shape({
    position: _propTypes.default.shape({
      vertical: _propTypes.default.oneOf(['top', 'middle', 'bottom']),
      horizontal: _propTypes.default.oneOf(['left', 'center', 'right'])
    }),
    hintData: _propTypes.default.string,
    hideDelay: _propTypes.default.number,
    showOnlyOnCollapse: _propTypes.default.bool
  }),
  icon: _propTypes.default.node,
  id: _propTypes.default.string,
  isCollapsed: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  title: _propTypes.default.string,
  url: _propTypes.default.string,
  isChildren: _propTypes.default.bool,
  hoverItemsClassName: _propTypes.default.string,
  handleOnParentMouseEnter: _propTypes.default.func,
  handleOnParentMouseLeave: _propTypes.default.func,
  badge: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
});

_defineProperty(SbMenuItem, "defaultProps", {
  className: null,
  children: null,
  currentUrl: null,
  handleActive: null,
  hint: null,
  icon: null,
  id: null,
  isCollapsed: false,
  onClick: function onClick() {},
  title: '',
  url: null,
  isChildren: false,
  hoverItemsClassName: null,
  handleOnParentMouseEnter: null,
  handleOnParentMouseLeave: null,
  badge: null
});
//# sourceMappingURL=sb-menu-item.js.map